export default __webpack_public_path__ + "media/images/marker-be38182ad8021679cb43c8c3f510132a.svg";